import React from 'react';

import { CLASS_NAMES } from '@rover/constants/src/platform/classNames.constants';
import { Box, Text } from '@rover/kibble/core';
import { BoxCommonProps } from '@rover/kibble/core/Box/Box.common';
import { TextCommonProps, TextNodes } from '@rover/kibble/core/Text/Text.common';
import { ValidAriaRolesOnBothWebAndRxn } from '@rover/kibble/core/utils';

type FormBasicValidationErrorProps = {
  errorMessageArialabel?: React.ComponentProps<TextNodes>['aria-label'];
  errorMessageArialive?: React.ComponentProps<TextNodes>['aria-live'];
  errorMessage: string | JSX.Element;
  boxProps?: BoxCommonProps;
  textProps?: Omit<TextCommonProps, 'children'>;
  id?: string;
  ariaRole?: ValidAriaRolesOnBothWebAndRxn;
};

const FormBasicValidationError = ({
  errorMessageArialabel,
  errorMessageArialive,
  errorMessage,
  ariaRole,
  boxProps,
  textProps,
  id = '',
}: FormBasicValidationErrorProps): JSX.Element => {
  return (
    <Box className={CLASS_NAMES.FORM_ERROR_CLASSNAME} {...boxProps} role={ariaRole}>
      <Text
        aria-label={errorMessageArialabel}
        aria-live={errorMessageArialive}
        size="100"
        textColor="error"
        data-testid="errorMessage"
        webProps={{ id }}
        {...textProps}
      >
        {errorMessage}
      </Text>
    </Box>
  );
};

export default FormBasicValidationError;
